import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useSelector } from "react-redux";
import {
  useGradeSubmissionMutation,
  useEditGradeSubmissionMutation,
} from "@/store/submissionApi";
import { toast } from "sonner";

const GradeModal = ({ submission, onClose }) => {
  console.log(submission, "submisison");
  const [marks, setMarks] = useState(submission?.marksObtained || "");
  const [feedback, setFeedback] = useState(submission?.feedback || "");
  const { user } = useSelector((state) => state.user);

  const [gradeSubmission, { isLoading: isGrading }] =
    useGradeSubmissionMutation();

  const [editGradeSubmission, { isLoading: isEditing }] =
    useEditGradeSubmissionMutation();

  const handleSubmit = async () => {
    if (marks === "") {
      toast.error("Please enter marks");
      return;
    }

    const formData = {
      marksObtained: Number(marks),
      feedback,
      instructorId: user?._id,
    };

    try {
      if (submission?.status === "graded") {
        await editGradeSubmission({
          submissionId: submission?._id,
          formData,
        }).unwrap();

        toast.success("Grade updated successfully!");
      } else {
        await gradeSubmission({
          submissionId: submission?._id,
          formData,
        }).unwrap();

        toast.success("Grade submitted successfully!");
      }

      onClose();
    } catch (error) {
      console.error("Error grading submission:", error);
      toast.error("Failed to save grade");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-xl w-[90%] sm:w-[400px] p-6 relative animate-fade-in">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-lg font-semibold mb-4 text-center">
          Grade Submission
        </h2>

        <div className="mb-3">
          <label className="text-sm font-medium">Marks</label>
          <input
            type="number"
            value={marks}
            onChange={(e) => setMarks(e.target.value)}
            placeholder={`Out of ${submission?.totalMarks}`}
            className="w-full mt-1 border border-gray-400 dark:border-gray-700 rounded-md px-3 py-2 bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <div className="mb-3">
          <label className="text-sm font-medium">Feedback</label>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Write constructive feedback..."
            className="w-full mt-1 border border-gray-400 dark:border-gray-700 rounded-md px-3 py-2 bg-white dark:bg-gray-800 text-gray-800 dark:text-white resize-none focus:ring-2 focus:ring-blue-500 focus:outline-none"
            rows={3}
          />
        </div>

        <Button
          onClick={handleSubmit}
          disabled={isGrading || isEditing}
          className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-md"
        >
          {isGrading || isEditing ? "Saving..." : "Submit Grade"}
        </Button>
      </div>
    </div>
  );
};

export default GradeModal;
